import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import common from '../../../common';
import {
    openMobilePlayerListing,
} from './../../../actions/FormationActions';
import FilterBtnMobile from './FilterBtnMobile';
import PlayerRecomendation from './PlayerRecomendation';
import SearchBtnMobile from './SearchBtnMobile';

class FilterHeaderMobile extends Component {
    hidePlayerListing = () => {
        this.props.openMobilePlayerListing(false);
    };

    render() {
        const { isPriceBoxOpenForMobile, isSearchOpenForBoth } = this.props;
        const scrollClass = common.makeClasses({
            'si-flexBox': true,
            'si-filters-group': isPriceBoxOpenForMobile,
            'si-opt-left': true,

        });
        return <div className="si-filter-wrap si-mob">
            <div className="si-filter-header si-flexBox">
                <div className="si-option-wrap">
                    {!isSearchOpenForBoth ? <div className={scrollClass} id="priceFilterScrollWrapper">
                        <FilterBtnMobile />
                    </div> : null}
                    {this.props.playerRecomendation && !isSearchOpenForBoth ? <PlayerRecomendation /> : null}
                    <SearchBtnMobile toScrollToTop={() => this.props.toScrollToTop()} />
                    {!isSearchOpenForBoth ? <div className="si-flexBox si-opt-right">
                        <div className="si-filter-items si-dwn-arrow"
                            onClick={() => this.hidePlayerListing()}>
                            <div className="si-filter-item-wrap">
                                <i className="icon-ucl-arrow_down" />
                            </div>
                        </div>
                    </div> : null}
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        isPriceBoxOpenForMobile: state.formationData.isPriceBoxOpenForMobile,
        isSearchOpenForBoth: state.formationData.isSearchOpenForBoth,
        playerRecomendation: state.formationData.playerRecomendation,
        IsFirstTimeRecomend: state.formationData.IsFirstTimeRecomend
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterHeaderMobile));


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/FilterHeaderMobile.js